<template>
    <div id="EasylunchPresencias" :key="$route.name">
        <template v-if="isLoading">
            Cargando...
        </template>
        <template v-else>
            <b-row>
                <b-col cols="9">
                    <presencias-quick-table ref="presenciasQuickTable" :tipo="$route.meta.tipo" :cedes-id="filtering.cedes_id" :grupos-id="filtering.grupos_id" />
                </b-col>
                <b-col cols="3">
                    <cedes-viewer v-model="filtering" :cedes="loadedData.lunch_cedes" :grupos="loadedData.lunch_grupo" @changed="triggerFilterChanged"/>
                </b-col>
            </b-row>
        </template>
    </div>
</template>

<script>
import presenciasQuickTable from './Presencias/quicktable.vue'
import {getGenerals, startGenerals, startFilters} from './Easylunch'
import CedesViewer from './elements/cedes-viewer.vue'
export default {
    name: 'EasylunchPresencias',
    components: { presenciasQuickTable, CedesViewer },
    data: () => {
        return {
            isLoading: false,
            loadedData: startGenerals(),
            filtering: startFilters()
        }
    },
    methods: {
        triggerFilterChanged( ){
            if(typeof this.$refs.presenciasQuickTable.refresh == 'function')
                setTimeout(this.$refs.presenciasQuickTable.refresh, 150)
        },
        async loadUp(){
            this.isLoading = true;
            let responseData = await getGenerals()
            if(responseData){
                this.loadedData = responseData;
            }
            this.isLoading = false;
        }
    },
    mounted() {
        this.loadUp()
    }
}
</script>

<style lang="less">
    #EasylunchPresencias {

    }
</style>